import React from 'react';

type Props = { sizeRem?: number; color?: string; label?: string; vertical?: boolean };

const CircularProgress: React.FC<Props> = ({ sizeRem = 2, color = '#6d28d9', label, vertical = false }) => {
  const size = `${sizeRem}rem`;
  const spinner = (
    <span
      aria-label={label || 'Cargando'}
      role="status"
      style={{
        display: 'block',
        width: size,
        height: size,
        borderRadius: '50%',
        border: `${Math.max(0.12 * sizeRem, 0.16)}rem solid #e5e7eb`,
        borderTopColor: color,
        animation: 'circular-spin 1s linear infinite',
        flexShrink: 0,
      }}
    />
  );

  return (
    <>
      <style>{`@keyframes circular-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      {vertical ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
          {spinner}
          {label && <span style={{ fontSize: '0.9rem', fontWeight: 500, color: '#6b7280' }}>{label}</span>}
        </div>
      ) : (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textAlign: 'left' }}>
          {spinner}
          {label && <span style={{ fontSize: '0.9rem', fontWeight: 600 }}>{label}</span>}
        </div>
      )}
    </>
  );
};

export default CircularProgress;
